import { datadogLogs } from '@datadog/browser-logs';
import SumoLogic from 'sumologic.js';

const sumoLogger = new SumoLogic(window.SUMOLOGIC_CONFIG);

export const infoLog = (message, context = {}) => {
    sumoLogger.info({ message, ...context });
    datadogLogs.logger.info(message, context);
}

export const errorLog = (message, context = {}) => {
  sumoLogger.error({ message, ...context });
  datadogLogs.logger.error(message, context);
};